var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cog-input" }, [
    _c(
      "div",
      {
        staticClass: "cog-upload",
        class: { "is-read-only": _vm.readonly },
        on: { paste: _vm.pasteFile }
      },
      [
        _c(
          "el-upload",
          {
            ref: "upload",
            attrs: {
              "show-file-list": false,
              "http-request": _vm.uploadFile,
              "on-preview": _vm.previewFile,
              "before-upload": _vm.beforeUpload,
              "file-list": _vm.initialFiles,
              disabled: _vm.readonly,
              limit: _vm.maxFiles,
              "on-exceed": _vm.limitExceeded,
              multiple: !_vm.maxFiles || _vm.maxFiles > 1,
              drag: !_vm.readonly && !_vm.limitReached,
              "aria-required": _vm.isRequired ? true : undefined,
              "aria-describedby":
                _vm.hasError && _vm.fullId ? _vm.fullId + "_error" : undefined,
              "aria-invalid": _vm.hasError ? true : undefined,
              "list-type": "picture",
              action: ""
            }
          },
          [
            !_vm.readonly && !_vm.limitReached
              ? [
                  _c(
                    "div",
                    { on: { click: _vm.handleUploadClicks } },
                    [
                      _c(
                        "c-button",
                        {
                          ref: "uploadButton",
                          staticClass:
                            "cog-button--secondary cog-upload__upload-button",
                          on: { click: _vm.uploadClicked }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$resource(
                                  "fileupload-default-upload-button-text"
                                )
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "cog-upload__drag-text",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$resource("fileupload-dropzone-message"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "transition-group",
          {
            staticClass: "cog-upload__list",
            attrs: { name: "cog-upload__list", tag: "ul" },
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          _vm._l(_vm.uploadFiles, function(file, i) {
            return _c(
              "li",
              { key: _vm.key(file.uid), ref: "uploadItems", refInFor: true },
              [
                _vm.hasThumbnail(file)
                  ? _c("img", {
                      staticClass: "cog-upload__thumbnail",
                      attrs: {
                        src: _vm.getThumbnail(file),
                        onerror: "this.className += ' error'"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("c-file-icon", {
                  key: "icon-" + i,
                  attrs: { extension: _vm.getExtension(file) }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "cog-upload__file-info" }, [
                  _c(
                    "a",
                    {
                      key: "anchor-" + file.uid,
                      staticClass: "cog-upload__link",
                      attrs: { href: file.url, target: "_blank" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.tryPreviewFile(file, $event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(file.name))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "cog-upload__file-size" }, [
                    _vm._v(_vm._s(_vm.getDisplayFileSize(file)))
                  ])
                ]),
                _vm._v(" "),
                file.percentage === 100 || file.status === "success"
                  ? [
                      _c(
                        "c-button",
                        {
                          key: "download-button-" + file.uid,
                          staticClass: "cog-upload__download-button",
                          attrs: {
                            "no-style": "",
                            title: _vm.getDownloadText(file)
                          },
                          on: {
                            click: function($event) {
                              return _vm.tryDownloadFile(file, $event)
                            }
                          }
                        },
                        [_c("i-download")],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.readonly
                        ? _c(
                            "c-button",
                            {
                              key: "remove-button-" + file.uid,
                              staticClass: "cog-upload__remove-button",
                              attrs: {
                                "no-style": "",
                                title: _vm.getRemoveText(file)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeFile(file.uid)
                                }
                              }
                            },
                            [_c("i-ex")],
                            1
                          )
                        : _vm._e()
                    ]
                  : [
                      _c("progress", {
                        key: "progress-" + file.uid,
                        attrs: { max: "100" },
                        domProps: { value: file.percentage }
                      }),
                      _vm._v(" "),
                      _c(
                        "c-button",
                        {
                          staticClass: "cog-upload__remove-button",
                          attrs: {
                            "no-style": "",
                            title: _vm.getRemoveText(file)
                          },
                          on: {
                            click: function($event) {
                              return _vm.cancelUpload(file.uid)
                            }
                          }
                        },
                        [_c("i-ex")],
                        1
                      )
                    ]
              ],
              2
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: "cog-error-message" } }, [
          _vm.error && !_vm.readonly
            ? _c("div", { staticClass: "cog-error-message" }, [
                _vm._v(_vm._s(_vm.error))
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }